/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElForm as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElTag as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "marginL10 red"
};
const _hoisted_2 = {
  class: "marginL10 red"
};
const _hoisted_3 = {
  class: "marginL10 red"
};
const _hoisted_4 = {
  class: "marginL10 red"
};
const _hoisted_5 = {
  class: "flex items-center"
};
const _hoisted_6 = {
  class: "flex flex-wrap",
  style: {
    "max-width": "400px"
  }
};
const _hoisted_7 = {
  class: "dialog-footer"
};
import USwitch from '@ultra/share/components/USwitch/index.vue';
import { Plus } from '@element-plus/icons-vue';
import { apiUsdkSwitchConfGetCheckSign, apiUsdkSwitchConfBatchFobiddenSwitch, apiUsdkSwitchConfSaveCheckSign } from '@/api/usdk';
import { UseSwitchCommon } from '../hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'confForbidden',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const {
      gid,
      switchType
    } = UseSwitchCommon();
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const form = ref({});
    const white = ref('');
    const handleClose = () => {
      dialogVisible.value = false;
      initForm();
    };
    const changeWhiteList = (type, index) => {
      if (type === 'add') {
        if (white.value) {
          form.value.sign.whiteList.push(white.value);
          white.value = '';
        }
      } else if (type === 'minus') {
        form.value.sign.whiteList.splice(index, 1);
      }
    };
    const show = payload => {
      dialogVisible.value = true;
      const item = payload.data;
      form.value.cid = item.cid;
      form.value.channel = item.cname;
      for (let key in form.value) {
        if (typeof form.value[key] === 'object') {
          let val = item['status_' + form.value[key].type];
          let sw_status = switchType(val, form.value[key].type).open;
          form.value[key].sw_status = sw_status;
          form.value[key].sw_tip = item['tip_' + form.value[key].type];
          form.value[key].id = item['id_' + form.value[key].type];
          if (key === 'sign') {
            form.value[key].sw_status = sw_status ? 0 : 1;
          }
        }
      }
      apiUsdkSwitchConfGetCheckSign({
        gid,
        id: item.id_6,
        cname: item.cname,
        cid: item.cid
      }).then(res => {
        if (res.code === 0) {
          form.value.sign.whiteList = res.data.md5Val && res.data.md5Val.split(',') || [];
        }
      });
    };
    const handleOk = () => {
      let copyForm = JSON.parse(JSON.stringify(form.value));
      let params = {
        gid: gid,
        cid: copyForm.cid,
        channel: copyForm.channel,
        data: []
      };
      confirmLoading.value = true;
      for (let key in copyForm) {
        if (typeof copyForm[key] === 'object' && key != 'sign') {
          params.data.push(copyForm[key]);
        }
      }
      params.data = JSON.stringify(params.data);
      let signParams = {
        gid: gid,
        cid: copyForm.cid,
        channel: copyForm.channel,
        ...copyForm.sign
      };
      if (signParams.whiteList.length) {
        signParams.md5Val = signParams.whiteList.join(',');
      }
      signParams.status = signParams.sw_status ? 0 : 1;
      delete signParams.whiteList;
      delete signParams.sw_key;
      delete signParams.sw_status;
      apiUsdkSwitchConfBatchFobiddenSwitch(params).then(res => {
        apiUsdkSwitchConfSaveCheckSign(signParams).then(res => {
          if (res.code === 0) {
            emits('success');
            handleClose();
            confirmLoading.value = false;
          }
        });
      });
    };
    const initForm = () => {
      form.value = {
        cid: '',
        add: {
          type: 0,
          sw_key: 'sw_new_login',
          sw_tip: '',
          sw_status: 1
        },
        login: {
          type: 1,
          sw_key: 'sw_login',
          sw_tip: '',
          sw_status: 1
        },
        pay: {
          type: 2,
          sw_key: 'sw_pay',
          sw_tip: '',
          sw_status: 1
        },
        sign: {
          type: 6,
          sw_key: '',
          sw_tip: '',
          sw_status: 1,
          whiteList: []
        },
        checkPay: {
          type: 8,
          sw_key: 'sw_check_order_status',
          sw_status: 1
        },
        customer: {
          type: 15,
          sw_key: 'sw_kf',
          sw_tip: '',
          sw_status: 1
        }
      };
    };
    onMounted(() => {
      initForm();
    });
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_tag = __unplugin_components_3;
      const _component_el_form = __unplugin_components_4;
      const _component_el_dialog = __unplugin_components_5;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "配置",
        width: "600px",
        "before-close": () => handleClose()
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => handleClose())
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: _unref(confirmLoading),
          type: "primary",
          onClick: _cache[10] || (_cache[10] = $event => handleOk())
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "ruleForm",
          model: _unref(form),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "注册："
          }, {
            default: _withCtx(() => [_createVNode(USwitch, {
              modelValue: _unref(form).add.sw_status,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).add.sw_status = $event)
            }, null, 8, ["modelValue"]), _createTextVNode(), _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(form).add.sw_status ? '开启后该渠道将允许所有玩家注册账号' : '关闭后该渠道将不允许所有玩家注册账号'), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "禁用提示："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).add.sw_tip,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).add.sw_tip = $event),
              placeholder: "请输入禁用提示"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "登录："
          }, {
            default: _withCtx(() => [_createVNode(USwitch, {
              modelValue: _unref(form).login.sw_status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).login.sw_status = $event)
            }, null, 8, ["modelValue"]), _createTextVNode(), _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(form).login.sw_status ? '开启后该渠道所有玩家将正常使用登录功能' : '关闭后该渠道所有玩家将不能使用登录功能。'), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "禁用提示："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).login.sw_tip,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).login.sw_tip = $event),
              placeholder: "请输入禁用提示"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "支付："
          }, {
            default: _withCtx(() => [_createVNode(USwitch, {
              modelValue: _unref(form).pay.sw_status,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).pay.sw_status = $event)
            }, null, 8, ["modelValue"]), _createTextVNode(), _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(form).pay.sw_status ? '开启后该渠道所有玩家将正常使用支付功能' : '关闭后该渠道所有玩家将不能使用支付功能。'), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "禁用提示："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).pay.sw_tip,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).pay.sw_tip = $event),
              placeholder: "请输入禁用提示"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "签名校验："
          }, {
            default: _withCtx(() => [_createVNode(USwitch, {
              modelValue: _unref(form).sign.sw_status,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).sign.sw_status = $event)
            }, null, 8, ["modelValue"]), _createTextVNode(), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(form).sign.sw_status ? '开启后只有使用白名单内签名的包体才能正常登录。' : '关闭后所有包体都能正常登录。'), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "签名白名单："
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
              modelValue: _unref(white),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(white) ? white.value = $event : null),
              placeholder: "请输入签名白名单"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              class: "marginL10",
              onClick: _cache[8] || (_cache[8] = $event => changeWhiteList('add')),
              size: "small",
              type: "primary",
              circle: "",
              icon: _unref(Plus)
            }, null, 8, ["icon"])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).sign.whiteList, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                style: {
                  "font-size": "12px",
                  "margin-right": "6px"
                },
                key: index
              }, [_createVNode(_component_el_tag, {
                closable: "",
                onClose: $event => changeWhiteList('minus', index)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                _: 2
              }, 1032, ["onClose"])]);
            }), 128))])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "before-close"]);
    };
  }
});